import { FiEdit } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getPaymentInfo } from '../../modules/selectors/paymentInfo';
import { RxCross1 } from 'react-icons/rx';

export const Title = styled.h3`
  font-weight: 300;
  color: #1d1d1d;
`;

export const FiEditBtn = styled(FiEdit)`
  cursor: pointer;
`;

export const RxCross1Btn = styled(RxCross1)`
  cursor: pointer;
`;

export function canEnablePayPal(payPal: { payPalClientId: string; payPalSecret: string }): boolean {
  return !!payPal.payPalClientId && !!payPal.payPalSecret;
}

export function canEnableIBAN(iban: { iban: string; accountHolder: string }): boolean {
  return !!iban.iban && !!iban.accountHolder;
}

export function useUserHasPayinPaymentMethod(): boolean {
  const { shopPayinPaymentMethod } = useSelector(getPaymentInfo);

  return shopPayinPaymentMethod.loaded && !!shopPayinPaymentMethod?.type;
}

export function obfuscateString(str: string): string {
  const offset = 4;

  if (str.length - offset * 2 <= offset) {
    return [
      str.slice(0, 1),
      new Array(str.length - 2).fill('*').join(''),
      str.slice(str.length - 1)
    ].join('');
  }

  return [
    str.slice(0, offset),
    new Array(str.length - offset * 2).fill('*').join(''),
    str.slice(str.length - offset)
  ].join('');
}
